<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :submit="submit"
    :status="status"
    :breadcrumbs="[
        {
          text: 'Información y soporte',
          disabled: false,
          href: '/admin/helps'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: $route.params.id ? 'Editar' : 'Crear',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="title"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Titulo</div>
                <v-text-field
                  :error-messages="errors"
                  v-model="data.title"
                  label="Titulo"
                  prepend-inner-icon="fas fa-file"
                  solo
                  hide-details="auto"
                  class="input-base"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="type"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Tipo</div>
                <v-select
                  solo
                  hide-details="auto"
                  class="input-base"
                  append-icon="$caretDownFormIcon"
                  :error-messages="errors"
                  v-model="data.type"
                  label="Tipo"
                  :items="types"
                >
                  <template slot="no-data">
                    <v-alert :value="true"> There is no info to show </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="help_options"
                rules="required"
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Opciones</div>
                <v-select
                  solo
                  hide-details="auto"
                  class="input-base"
                  append-icon="$caretDownFormIcon"
                  :error-messages="errors"
                  v-model="data.help_options"
                  label="Opciones"
                  :items="help_options"
                  multiple
                  item-text="title"
                  item-value="id"
                >
                  <template slot="no-data">
                    <v-alert :value="true">
                      No hay información para mostrar
                    </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  async created() {
    const self = this;
    await self.$store.dispatch("Help_options/getListAll", {
      show_all: "enable",
    });
  },
  computed: {
    ...mapState({
      status: (state) => state.Helps.status,
      help_options: (state) => state.Help_options.list,
    }),
  },
  data() {
    return {
      storeName: "Helps",
      parentStoreName: "Helps",
      title: "Ayuda",
      types: ["Owner", "Driver", "Ambos"],
      data: {
        title: "",
        type: "",
        help_options: [],
      },
    };
  },
};
</script>
